// import { toastStore } from '../toast/toastStore';
import { getErrorMessage } from "@zickko/shared";
import { toastStore } from "./toastStore";

/**
 * Utility that performs an async operation with a message to the user, and also sets the busy flag.
 *
 * If `onError` is not defined, this method will throw an exception.
 *
 * If `onSuccess` is defined, `onSuccess` is called with the result.
 */
export type AsyncOperationProps<T> = {
  fn: () => Promise<T>;
  successMessage?: string;
  loadingMessage?: string;
  setBusyFlag?: (busyFlag: boolean) => void;
  onSuccess?: (result: T) => void;
  onError?: (e: any) => void;
  onComplete?: () => void;
  hideToastOnError?: boolean;
};

export const asyncOperation = async <T>(args: AsyncOperationProps<T>): Promise<T | undefined> => {
  //
  const {
    fn: asyncFn,
    successMessage,
    loadingMessage,
    setBusyFlag,
    onSuccess,
    onError,
    onComplete,
    hideToastOnError,
  } = args;

  let hide;
  if (loadingMessage) hide = toastStore.loading(loadingMessage);

  try {
    setBusyFlag && setBusyFlag(true);
    const result = await asyncFn();
    successMessage && toastStore.success(successMessage);
    onSuccess && onSuccess(result);
    return result;
  } catch (e) {
    console.error(e);
    !hideToastOnError && toastStore.error(getErrorMessage(e) ?? `Error: ${loadingMessage?.toLowerCase()}`);
    onError && onError(e);
    // throw e;
  } finally {
    setBusyFlag && setBusyFlag(false);
    hide && hide();
    onComplete && onComplete();
  }
};
